module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "login-box"
  }, [_c('div', [_c('div', {
    staticClass: "login-contain"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showErrMsg),
      expression: "showErrMsg"
    }],
    staticClass: "errMsg"
  }, [_vm._v("邮箱和密码不正确！")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showErrMsg2),
      expression: "showErrMsg2"
    }],
    staticClass: "errMsg"
  }, [_vm._v("请输入你的邮箱和密码！")]), _vm._v(" "), _c('ul', [_c('li', [_c('label', [_c('span', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("邮箱")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userData.email),
      expression: "userData.email"
    }],
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "type": "text",
      "placeholder": "邮箱"
    },
    domProps: {
      "value": (_vm.userData.email)
    },
    on: {
      "keydown": _vm.input,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userData, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('label', [_c('span', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("密码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userData.pwd),
      expression: "userData.pwd"
    }],
    ref: "pwd",
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "type": "password",
      "placeholder": "密码"
    },
    domProps: {
      "value": (_vm.userData.pwd)
    },
    on: {
      "keydown": _vm.input,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userData, "pwd", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "join"
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px"
    },
    on: {
      "click": _vm.doJoin
    }
  }, [_vm._v("新用户注册")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "do-login"
  }, [_c('button', {
    staticStyle: {
      "font-size": "16px"
    },
    on: {
      "click": _vm.doLogin
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#999",
      "margin-left": "70px",
      "margin-top": "20px",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.doReset
    }
  }, [_vm._v("忘记密码 ?")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header",
    staticStyle: {
      "text-align": "left",
      "font-size": "16px"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./tiantanlogo.png"),
      "alt": ""
    }
  }), _vm._v("登录\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22971262"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tiantan/login_cn.vue
// module id = 777
// module chunks = 10